import FormField from './formField';
import SelectFormField from './selectFormField';

export const inputNames = {
	apartmentId: 'apartmentId', // Not included as a field in the form
	apartmentAddress: 'apartmentAddress',
	addressNumber: 'addressNumber',
	realEstateId: 'realEstateId',
	zipAndLocation: 'zipAndLocation',
	name: 'name',
	ssn: 'ssn',
	address: 'address',
	zip: 'zip',
	email: 'email',
	phone: 'phone',
	cellPhone: 'cellPhone',
	comments: 'comments',
	coTenantName: 'coTenantName',
	coTenantSsn: 'coTenantSsn',
	coTenantEmail: 'coTenantEmail',
	coTenantCellPhone: 'coTenantCellPhone',
	taxReport: 'taxReport',
	cashPaymentOverview: 'cashPaymentOverview',
	submissionArgument: 'submissionArgument',
	creditInfoApproval: 'creditInfoApproval',
	creditRating: 'creditRating',
	debtSummary: 'debtSummary'
};

export const getInitialValues = (apartment, authInfo) => ({
	[inputNames.apartmentId]: apartment.Id,
	[inputNames.apartmentAddress]: apartment.Address,
	[inputNames.addressNumber]: apartment.AddressNumber,
	[inputNames.realEstateId]: apartment.RealEstateId,
	[inputNames.zipAndLocation]: apartment.Zip,
	[inputNames.name]: authInfo.Name,
	[inputNames.ssn]: authInfo.SSN,
	[inputNames.address]: '',
	[inputNames.zip]: '',
	[inputNames.email]: '',
	[inputNames.phone]: '',
	[inputNames.cellPhone]: '',
	[inputNames.comments]: '',
	[inputNames.coTenantName]: '',
	[inputNames.coTenantSsn]: '',
	[inputNames.coTenantEmail]: '',
	[inputNames.coTenantCellPhone]: '',
	[inputNames.creditInfoApproval]: false
});

export const getInitialActiveInputMapper = (initialValues) => {
	const mapper = {};

	Object.keys(initialValues).map((key) => {
		if(initialValues[key] && initialValues[key].length > 0) {
			mapper[key] = true;
		}
	});

	return mapper;
};

export const fields = {
	basicInfo: [
		{
			id: 1, fieldName: inputNames.apartmentAddress, readOnly: true, type: 'text', labelName: 'Götuheiti'
		},
		{
			id: 2, fieldName: inputNames.addressNumber, readOnly: true, type: 'text', labelName: 'Íbúðarnúmer'
		},
		{
			id: 3, fieldName: inputNames.realEstateId, readOnly: true, type: 'text', labelName: 'Fastanúmer'
		},
		{
			id: 4, fieldName: inputNames.zipAndLocation, readOnly: true, type: 'text', labelName: 'Póstnúmer og staður'
		}
	],
	renterInfo: [
		{
			id: 5, fieldName: inputNames.name, readOnly: true, type: 'text', labelName: 'Fullt nafn'
		},
		{
			id: 6, fieldName: inputNames.ssn, readOnly: true, type: 'text', labelName: 'Kennitala'
		},
		{
			id: 7, fieldName: inputNames.address, readOnly: false, type: 'text', labelName: 'Heimilisfang'
		},
		{
			id: 8, fieldName: inputNames.zip, readOnly: false, type: 'dropdown', labelName: 'Póstnúmer'
		},
		{
			id: 9, fieldName: inputNames.email, readOnly: false, type: 'text', labelName: 'Netfang'
		},
		{
			id: 10, fieldName: inputNames.phone, readOnly: false, type: 'text', labelName: 'Símanúmer'
		},
		{
			id: 11, fieldName: inputNames.cellPhone, readOnly: false, type: 'text', labelName: 'Farsími'
		},
		{
			id: 12, fieldName: inputNames.comments, readOnly: false, type: 'text', labelName: 'Athugasemd'
		}
	],
	additionalRenterInfo: [
		{
			id: 13, fieldName: inputNames.coTenantName, readOnly: false, type: 'text', labelName: 'Fullt nafn meðleigjanda'
		},
		{
			id: 14, fieldName: inputNames.coTenantSsn, readOnly: false, type: 'text', labelName: 'Kennitala meðleigjanda'
		},
		{
			id: 15, fieldName: inputNames.coTenantCellPhone, readOnly: false, type: 'text', labelName: 'Farsími'
		},
	 	{
			id: 16, fieldName: inputNames.coTenantEmail, readOnly: false, type: 'text', labelName: 'Netfang / Email address'
		},
	],
	files: [
		{
			id: 17, fieldName: inputNames.taxReport, fileNameBase: 'skattskyrsla_nyjasta', readOnly: false, type: 'text', labelName: 'Skattskýrsla (nýjasta)'
		},
		{
			id: 18, fieldName: inputNames.cashPaymentOverview, fileNameBase: 'stadgreidsluyfirlit_sl_12_man', readOnly: false, type: 'text', labelName: 'Staðgreiðsluyfirlit (s.l. 12 mánuði)'
		},
		{
			id: 19, fieldName: inputNames.submissionArgument, fileNameBase: 'rokstudningur', readOnly: false, type: 'text', labelName: 'Rökstuðningur'
		},
		{
			id: 22, fieldName: inputNames.creditRating, fileNameBase: 'lanshaefismat_creditinfo', readOnly: false, type: 'text', labelName: 'Lánshæfismat - Creditinfo'
		},
		{
			id: 23, fieldName: inputNames.debtSummary, fileNameBase: 'skuldastoduyfirlit_creditinfo', readOnly: false, type: 'text', labelName: 'Skuldastöðuyfirlit - Creditinfo'
		}
	],
	approvals: [
		{
			id: 20, fieldName: inputNames.creditInfoApproval, readOnly: false, type: 'checkbox', labelName: 'Umsækjandi/umsækjendur lýsa því yfir að framlögð gögn sem mat á umsókn byggir á eru rétt og samþykkja einnig að afhenda Leigufélaginu Bríeti ehf. frekari gögn til staðfestingar sé þess óskað.'
		}
	]
};

export const requiredValues = {
	[inputNames.apartmentAddress]: true,
	[inputNames.addressNumber]: true,
	[inputNames.realEstateId]: true,
	[inputNames.zipAndLocation]: true,
	[inputNames.name]: true,
	[inputNames.ssn]: true,
	[inputNames.address]: true,
	[inputNames.zip]: true,
	[inputNames.email]: true,
	[inputNames.phone]: true,
	[inputNames.cellPhone]: true,
	[inputNames.creditInfoApproval]: true
};

// Not in use atm, users should be able to request that Briet accesses
// files themselves if they don't have access to it
export const requiredFiles = {
	[inputNames.taxReport]: true,
	[inputNames.cashPaymentOverview]: true,
	[inputNames.submissionArgument]: true,
	[inputNames.creditRating]: true,
	[inputNames.debtSummary]: true
};

export const fieldTypeMapper = {
	text: FormField,
	dropdown: SelectFormField
};
